import { ItemModel } from 'models';
import { RawMergeDetailData } from './types';
import { ProcessStatus } from 'models/types';

export class MergeModel {
  id: string;
  status: ProcessStatus;
  mergedItem: ItemModel;
  baseItems: ItemModel[];

  constructor(rawMergeData: RawMergeDetailData) {
    this.id = rawMergeData.id;
    this.status = rawMergeData.status;
    this.mergedItem = new ItemModel(rawMergeData.merged_item);
    this.baseItems = (rawMergeData.base_items || []).map(item => new ItemModel(item));
  }

  containsArtist(artistId: string): boolean {
    // Check if the merged item has the artist
    if (this.mergedItem.artistId === artistId) {
      return true;
    }
    // Check if any base item has the artist
    return this.baseItems.some(item => item.artistId === artistId);
  }
}
